import React from "react";
import AppTile from "../common/AppTile";

const AppsGrid = ({
  apps = [],
  onAppClick,
  className = "",
  gridClassName = "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
  emptyMessage = "No apps available",
}) => {
  if (!apps.length) {
    return (
      <div className={`text-center py-8 ${className}`}>
        <p className="text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  const handleAppClick = (app) => {
    if (onAppClick) {
      onAppClick(app);
    } else if (app.url) {
      // If no custom onClick handler provided but app has URL, navigate to it
      window.location.href = app.url;
      // Or if using Next.js router:
      // router.push(app.url);
    }
  };

  return (
    <div className={`${className}`}>
      <div
        data-testid="apps-grid"
        role="grid"
        className={`grid ${gridClassName} gap-4`}
      >
        {apps.map((app, index) => (
          <AppTile
            key={app.id ?? `${app.title}-${index}`}
            icon={app.icon}
            title={app.title}
            subtitle={app.subtitle}
            color={app.color}
            bgColor={app.bgColor}
            url={app.url} // Pass URL to AppTile
            onClick={() => handleAppClick(app)}
            testId={`app-tile-${app.id}`}
          />
        ))}
      </div>
    </div>
  );
};

export default AppsGrid;